import { config } from '../config';
import { Category, Product, CartItem, Order } from '../types';

const fetchApi = async (endpoint: string, options?: RequestInit) => {
  const response = await fetch(`${config.apiUrl}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  return response.json();
};

export const api = {
  // Categories
  getCategories: (): Promise<Category[]> =>
    fetchApi('/products/categories'),

  // Products
  getProducts: (): Promise<Product[]> =>
    fetchApi('/products'),

  getProductsByCategory: (categoryId: number): Promise<Product[]> =>
    fetchApi(`/products/categories/${categoryId}/products`),

  getProduct: (id: number): Promise<Product> =>
    fetchApi(`/products/${id}`),

  // Cart
  getCart: (userId: string): Promise<CartItem[]> =>
    fetchApi(`/cart/${userId}`),

  addToCart: (userId: string, productId: number, quantity: number = 1): Promise<CartItem> =>
    fetchApi('/cart', {
      method: 'POST',
      body: JSON.stringify({ userId: parseInt(userId), productId, quantity }),
    }),

  updateCartItem: (itemId: number, quantity: number): Promise<CartItem> =>
    fetchApi(`/cart/${itemId}`, {
      method: 'PATCH',
      body: JSON.stringify({ quantity }),
    }),

  clearCart: (userId: string): Promise<void> =>
    fetchApi(`/cart/${userId}`, {
      method: 'DELETE',
    }),

  // Orders
  getOrders: (userId: string): Promise<Order[]> =>
    fetchApi(`/orders/user/${userId}`),

  getOrder: (id: number): Promise<Order> =>
    fetchApi(`/orders/${id}`),

  createOrder: (data: {
    userId: string;
    items: { productId: number; quantity: number }[];
    deliveryAddress?: string;
    phone?: string;
    comment?: string;
  }): Promise<Order> =>
    fetchApi('/orders', {
      method: 'POST',
      body: JSON.stringify({
        ...data,
        userId: parseInt(data.userId),
      }),
    }),
};
